import apiService from './api.service';

class SliderService {
  async getPublishedSliders() {
    try {
      const response = await apiService.post('/sliders/published', {}, {}, true);
      
      if (response && response.code === 1 && response.data) {
        return {
          success: true,
          data: response.data,
          message: response.message,
        };
      }
      
      return {
        success: false,
        data: [],
        message: response?.message || 'Failed to fetch sliders',
      };
    } catch (error) {
      return {
        success: false,
        data: [],
        message: error.message || 'An error occurred while fetching sliders',
      };
    }
  }

  transformSliderData(apiSliders) {
    // Filter out unpublished and deleted sliders
    return apiSliders
      .filter(slider => slider.IsPublished !== false && !slider.IsDeleted)
      .map(slider => {
        const transformed = {
          id: slider.SliderId || slider.Id || slider.id,
          image: slider.ImageUrl || slider.Image || slider.image || '',
          title: slider.Title || slider.title || slider.Caption || '',
          subtitle: slider.Subtitle || slider.subtitle || slider.SubTitle || '',
          description: slider.Caption ||  '',
          link: slider.Link || slider.link || slider.Url || '',
          sortOrder: slider.SortOrder || slider.sortOrder || 0,
        };
        
        return transformed;
      });
  }
}

export default new SliderService();
